var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg95(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st18{fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st18",
    cx: 24.26,
    cy: 24.17,
    rx: 21.48,
    ry: 16.58
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.85,33.25 19.85,34.87 10.58,34.87  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.79,33.69l13.46-0.81l0.29,1.99l2.57-0.37l-0.18-2.39l0.18-2.91h-3.6v-1.07h3.46l-0.55-9.6h0.51l0.18,3.05l1.36-0.11 l-0.4-4.01h-1.69l-0.29-2.98c0,0-0.26-1.43-1.69-1.25l-15.74,1.07c0,0-1.8,0.18-1.8,1.69l0.18,2.87l-1.73,0.15l0.29,4.16l1.21-0.07 l-0.04-3.05l0.4,0.07l0.66,8.94l3.57-0.15v1.62h-3.57l0.51,4.16l2.32-0.07L22.79,33.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M36.33,17.42l-15.19,0.75c-0.55,0.03-1.02-0.4-1.05-0.95l-0.04-0.84c-0.03-0.55,0.4-1.02,0.95-1.05l15.19-0.75 c0.55-0.03,1.02,0.4,1.05,0.95l0.04,0.84C37.31,16.92,36.89,17.39,36.33,17.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M35.37,26.31L23,26.92c-1.1,0.05-2.04-0.8-2.1-1.9l-0.18-3.73c-0.05-1.1,0.8-2.04,1.9-2.1l12.36-0.61 c1.1-0.05,2.04,0.8,2.1,1.9l0.18,3.73C37.32,25.32,36.46,26.26,35.37,26.31z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg95);
export default __webpack_public_path__ + "static/media/95.810676999633f0095bc1c831cbb2f82f.svg";
export { ForwardRef as ReactComponent };